export default __webpack_public_path__ + "static/media/Behance.18d5fe78.svg";